import React from "react";

export default function Affiliate() {
  return <div>This is Astroworker's Affiliate page.</div>;
}
